import { render, staticRenderFns } from "./VProgress.vue?vue&type=template&id=f1b2cc38&scoped=true"
import script from "./VProgress.vue?vue&type=script&lang=js"
export * from "./VProgress.vue?vue&type=script&lang=js"
import style0 from "./VProgress.vue?vue&type=style&index=0&id=f1b2cc38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b2cc38",
  null
  
)

export default component.exports